import LazyImage from "components/LazyImage";
import styles from './intro.module.css';
import global from '../bid.module.css';
import {ReactNode } from "react";

type Props = {
  title: ReactNode,
  image: {
    format: {
      original: {
        uri: string
      }
    }
  },
  text: string
}

const Intro = ({ title, image, text }: Props) => (
  <section className={`${styles.Container} ${global.Container}`}>
    {image?.format?.original?.uri && (
      <div>
        <LazyImage layout='fill' objectFit='contain' alt='Experience Guildford - Business Improvement District' src={`${process.env.NEXT_PUBLIC_APP_MEDIA_URL}${image.format.original.uri}`} />
      </div>
    )}
    <h1>
      {title}
    </h1>
    <span>
      <p>{text}</p>
    </span>
  </section>
);

export default Intro;
